module.exports = __webpack_public_path__ + "img/Monte_Kope_118.449a92b8.jpg";